
export function createElementFromHTML<T extends ChildNode>(htmlString: string)
{
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild as T;
}
